import { Routes } from '@angular/router';
import { ProfilePage } from '@profile-app/pages/profile-page/profile.page';
import { NotificationsPage } from '@profile-app/pages/notifications-page/notifications-page.component';

export const appRoutes: Routes = [
  {
    path: '', pathMatch: 'full', redirectTo: '/profile'
  },
  {
    path: 'profile',
    component: ProfilePage,
  },
  {
    path: 'notifications',
    component: NotificationsPage,
    data: {
      breadcrumb: ['Notifications', 'List']
    }
  },
];
